import * as React from 'react';

const SvgNotificationSettingsSolid = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M5.25 9.676a6.75 6.75 0 0 1 13.5 0v.366a1.97 1.97 0 0 0-1.939-1.616h-.583a2.015 2.015 0 0 0-2 1.763l-.014.118a.275.275 0 0 1-.38.22l-.118-.05a2.035 2.035 0 0 0-2.544.854l-.244.419a2.036 2.036 0 0 0 .538 2.654l.125.094a.223.223 0 0 1 0 .356l-.125.094a2.036 2.036 0 0 0-.538 2.654l.244.419c.156.268.366.488.608.654a25 25 0 0 1-2.028-.1l-.002.1a2.25 2.25 0 0 0 4.467.39l.012.098c.08.634.45 1.169.966 1.478a3.75 3.75 0 0 1-6.934-2.246 24.6 24.6 0 0 1-4.832-1.244.75.75 0 0 1-.298-1.205 8.22 8.22 0 0 0 2.119-5.52zm10.978.25a.515.515 0 0 0-.51.45l-.016.12a1.775 1.775 0 0 1-2.446 1.415l-.118-.05a.535.535 0 0 0-.67.225l-.244.419a.536.536 0 0 0 .142.699l.125.094a1.722 1.722 0 0 1 0 2.756l-.125.094a.536.536 0 0 0-.142.699l.244.418a.536.536 0 0 0 .67.225l.118-.05a1.775 1.775 0 0 1 2.446 1.416l.015.12c.033.257.252.45.511.45h.583a.47.47 0 0 0 .467-.412l.008-.059a1.85 1.85 0 0 1 2.55-1.476l.063.026a.49.49 0 0 0 .613-.205l.304-.522a.446.446 0 0 0-.118-.582l-.03-.023a1.872 1.872 0 0 1 0-2.995l.03-.022a.446.446 0 0 0 .118-.582l-.304-.522a.49.49 0 0 0-.613-.206l-.063.027a1.85 1.85 0 0 1-2.55-1.477l-.008-.059a.47.47 0 0 0-.466-.411zm2.018 4.75c0 .618-.337 1.193-.874 1.5a1.77 1.77 0 0 1-1.748 0 1.74 1.74 0 0 1-.874-1.5c0-.619.337-1.193.874-1.5a1.77 1.77 0 0 1 1.748 0c.537.307.874.881.874 1.5"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgNotificationSettingsSolid;
